PegasusTemplate.FragmentView = Em.View.extend({
  classNames: ['fragment'],

  templateName: 'fragment',

  type: 'Fragment',

  extraStyles: function() {
    return '';
  }
});
